// ISU College Categories
export const ISU_COLLEGES = [
  'College of Applied Science and Technology',
  'College of Arts and Sciences',
  'College of Business',
  'College of Education',
  'College of Engineering',
  'Interdisciplinary Studies',
  'Mennonite College of Nursing',
  'Wonsook Kim College of Fine Arts'
];

// General Listing Categories
export const LISTING_CATEGORIES = [
  'Furniture & Dorm Essentials',
  'Electronics & Tech',
  'Textbooks & School Supplies',
  'Clothing & Accessories',
  'Transportation',
  'Home & Kitchen',
  'Entertainment & Hobbies',
  'Sports & Fitness',
  'Art & Music Supplies',
  'Beauty & Personal Care',
  'Pet Supplies',
  'Local Businesses / Food',
  'Services',
  'Miscellaneous',
  'Free & Giveaways'
];

// Combined options for display
export const CATEGORY_OPTIONS = [
  { label: '── ISU Colleges ──', isHeader: true },
  ...ISU_COLLEGES.map(college => ({ value: college, label: college })),
  { label: '── General Categories ──', isHeader: true },
  ...LISTING_CATEGORIES.map(category => ({ value: category, label: category }))
];

// Flat list of all categories for validation
export const ALL_CATEGORIES = [...ISU_COLLEGES, ...LISTING_CATEGORIES];
